// Diretive to broadcast if the heritage banner was clicked
angular.module('westBerkshireEvents.bannerfilter').directive('wbBannerFilter', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        controller: wbBannerFilterController
    };
});

function wbBannerFilterController($scope, $rootScope) {
    // question filters
    $scope.applyQuestionFilter = (bb, type) => {
        $rootScope.$broadcast('ApplyQuestionFilter', type);
    }
    // categoru filters
    $scope.applyCategoryFilter = (bb, type) => {
        $rootScope.$broadcast('ApplyCategoryFilter', type);
    }
}


// WEBPACK FOOTER //
// ../src/public/javascripts/banner-filter/banner_filter.directive.js